var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03673 7.51962C9.03639 8.18753 8.77075 8.82796 8.29822 9.30001C7.8257 9.77205 7.18502 10.0371 6.5171 10.0367C5.84919 10.0364 5.20877 9.77075 4.73672 9.29823C4.26467 8.8257 3.99967 8.18502 4 7.5171C4.00033 6.84919 4.26598 6.20877 4.7385 5.73672C5.21102 5.26467 5.85171 4.99967 6.51962 5C7.18753 5.00033 7.82796 5.26598 8.30001 5.7385C8.77205 6.21102 9.03706 6.85171 9.03673 7.51962ZM9.11228 11.9016H4.07555V27.6665H9.11228V11.9016ZM17.0703 11.9016H12.0588V27.6665H17.0199V19.3937C17.0199 14.7851 23.0262 14.357 23.0262 19.3937V27.6665H28V17.6812C28 9.91207 19.1102 10.2017 17.0199 14.017L17.0703 11.9016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/IconLinkedin.01babbf6f12957f9da94f4ea5963a3bf.svg";
export { ForwardRef as ReactComponent };